import React from 'react';
import { connectDeep } from 'redux-utils';

import App from 'models/app';

import Gallery from 'components/Gallery';
import DiscoveryPage from 'components/DiscoveryPage';
import { mapPageLayoutItems } from 'components/DiscoveryPage/utils';

import MyClocks from './MyClocks';

import { translations } from 'i18n';


const mapStateToProps = (state) => {
  const {
    installed: {
      loading: installedLoading,
      error: installedError,
      entries: installedEntries = []
    },
    features: { flags, loading: featuresLoading },
    fetchPageLayout: { loading: fetchPageLayoutLoading },
    pageLayoutItems: { CLOCK: pageLayoutItems = [] },
    favorites: favoritesList
  } = state.registry;

  const { query: { selectedApp } = {} } = state.location;

  const { direction, osPermissions } = state.gallery;

  const installedClocks = [];
  for (const { appId } of installedEntries) {
    const app = App.selectFromState(appId, state);
    if (app && app.isInstalledOrInstalling && app.isClock) {
      installedClocks.push(app);
    }
  }

  const favorites = [];
  for (const appId of favoritesList) {
    const app = App.selectFromState(appId, state);
    if (app && app.isClock) {
      favorites.push(app);
    }
  }

  let showSearch = false;
  if (flags) {
    showSearch = flags.showSearch;
  }

  const loading = installedEntries.length > 0 ? false : installedLoading;
  const error = installedError;
  const bannerLists = [];
  const collections = [];

  pageLayoutItems.forEach((item) => {
    if (item.type === 'BANNER_LIST') {
      bannerLists.push(item);
    } else if (item.type === 'APP_LIST') {
      const apps = item.apps
        .map((app) => App.selectFromState(app.id, state))
        .filter((app) => app && app.id);
      collections.push({ ...item, apps });
    }
  });

  return {
    loading: loading || fetchPageLayoutLoading || featuresLoading,
    bannerLists,
    collections,
    pageLayoutItems: mapPageLayoutItems(pageLayoutItems, state),
    error,
    osPermissions,
    showSearch,
    showHiggsCU2: flags.showHiggsCU2,
    direction,
    installedApps: installedClocks,
    selectedApp,
    favorites,
    flags
  };
};

const ClockDiscoveryPage = (props) => (
  <DiscoveryPage isClock {...props} />
);

export default connectDeep(mapStateToProps)((props) => {
  const {
    page: {
      ClockGallery: { listPageName, installedPageName, pageName }
    }
  } = translations;

  return (
    <Gallery
      rootUrl="/clocks"
      installedPageName={installedPageName()}
      listPageName={listPageName()}
      pageName={pageName()}
      DiscoveryPage={ClockDiscoveryPage}
      InstalledPage={MyClocks}
      {...props}
    />
  );
});
